(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productV2JSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productV2VariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    // grab sticky element
    const stickyATC = section.querySelector('.productV2Sticky');

    /**************
     Product Swiper
     ***************/

        // thumbnail gallery drives the main slider via swiper's thumbs module
    const thumbsSwiper = new Swiper(section.querySelector(".productV2VisualThumbs"), {
            slidesPerView: 3,
            spaceBetween: 12
        });

    const productSwiper = new Swiper(section.querySelector(".productV2VisualMain"), {
        slidesPerView: 1,
        spaceBetween: 0,
        thumbs: {
            swiper: thumbsSwiper,
        },
    });

    /**************
     Update Product
     ***************/

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", async function () {
            // fetch new url information to update the pdp
            if (this.classList.contains("productV2OptionsItemValuesLabelInput")) {
                // create array of selected option ids
                const optionIDs = [];
                section.querySelectorAll(".productV2OptionsItemValuesLabelInput:checked").forEach(element => {
                    optionIDs.push(element.dataset.id);
                })

                // fetch updated variant data
                const response = await fetch(`${window.location.pathname}?view=active-variant&option_values=${optionIDs.join(',')}`)
                    .then(response => response.json());

                // update active variant
                activeVariant = response.active_variant;
            }
            // update the pdp info
            updateProduct().catch(err => console.error(err));
        });
    })

    async function updateProduct() {

        let sellingPlanExists = section.querySelector(".productV2SellingPlans") || false;
        let units = parseInt(section.querySelector(".productV2OptionsItemValuesLabelInput:checked").dataset.units);

        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            section.querySelector(".productV2ATC").disabled = true;
            section.querySelector(".productV2ATCText").textContent = "Not Available";
            return;
        }

        /**************
         Selling Plan
         ***************/

        let atcPrice = activeVariant.price;

        if (sellingPlanExists) {
            const isSubscriptionActive = !!section.querySelector(".productV2Subscription.active");
            const selectedPlanId = parseInt(section.querySelector(".productV2SubscriptionSelector")?.value);

            // find the matching selling_plan_allocation
            let activeVariantPlan = activeVariant.selling_plan_allocations?.[0];
            for (let plan of activeVariant.selling_plan_allocations || []) {
                if (plan.selling_plan_id === selectedPlanId) {
                    activeVariantPlan = plan;
                    break;
                }
            }

            if (activeVariantPlan) {
                // update subscription price display
                const subPriceReal = section.querySelector(".productV2SubscriptionPriceReal");
                if (subPriceReal) subPriceReal.textContent = price(activeVariantPlan.price) + " Per Box";

                const subPriceCompare = section.querySelector(".productV2SubscriptionPriceCompare");
                if (subPriceCompare) {
                    if (activeVariantPlan.compare_at_price > activeVariantPlan.price) {
                        subPriceCompare.textContent = price(activeVariantPlan.compare_at_price);
                        subPriceCompare.style.display = "";
                    } else {
                        subPriceCompare.style.display = "none";
                    }
                }

                const subPerDose = section.querySelector(".subscriptionPricePerDose");

                if (subPerDose) subPerDose.textContent = price(activeVariantPlan.price / units) + "/unit";

                if (isSubscriptionActive) {
                    atcPrice = activeVariantPlan.price;
                }
            }

            // always update OTP prices
            const otpPrice = section.querySelector(".productV2OTPPrice");
            if (otpPrice) otpPrice.textContent = price(activeVariant.price) + " Per Box";

            const otpPerDose = section.querySelector(".OTPPricePerDose");
            if (otpPerDose) otpPerDose.textContent = price(activeVariant.price / units) + "/unit";
        }

        /**************
         Upsell
         ***************/

            // add upsell variant price if the toggle is checked
        const upsellInput = section.querySelector(".productV2UpsellLabelInput");
        if (upsellInput?.checked) {
            const upsellVariant = JSON.parse(upsellInput.dataset.variant);
            atcPrice += upsellVariant.price;
        }

        /**************
         Price
         ***************/

        // update price on buttons
        section.querySelector(".productV2ATCPrice").textContent = price(atcPrice);
        if (stickyATC) {
            section.querySelector(".productV2StickyAtcPrice").textContent = price(activeVariant.price);
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV2ATC").disabled = false;
            section.querySelector(".productV2ATCText").textContent = "ADD TO CART ? ";
            if (stickyATC) {
                stickyATC.querySelector(".productV2StickyAtc").disabled = false;
                stickyATC.querySelector(".productV2StickyAtcText").textContent = "Add ? ";
            }
        } else {
            section.querySelector(".productV2StickyAtc").disabled = true;
            section.querySelector(".productV2ATCText").textContent = "SOLD OUT";
            section.querySelector(".productV2ATCPrice").textContent = "";
            if (stickyATC) {
                stickyATC.querySelector(".productV2StickyAtc").disabled = true;
                stickyATC.querySelector(".productV2StickyAtcText").textContent = "SOLD OUT";
                section.querySelector(".productV2StickyAtcPrice").textContent = "";
            }
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    // updateProduct().catch(err => console.error(err));
    section.querySelector('.productV2OptionsItemValuesLabelInput.preselct')?.click();

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV2ATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for subscription and add if selected
        const isSubscriptionActive = !!section.querySelector(".productV2Subscription.active");
        if (isSubscriptionActive) {
            const selectedPlanId = section.querySelector(".productV2SubscriptionSelector")?.value;
            if (selectedPlanId) {
                formData.items[0].selling_plan = selectedPlanId;
            }
        }

        // add upsell variant as a second item if the toggle is checked
        const upsellInput = section.querySelector(".productV2UpsellLabelInput");
        if (upsellInput?.checked) {
            const upsellVariant = JSON.parse(upsellInput.dataset.variant);
            formData.items.push({
                quantity: 1,
                id: upsellVariant.id,
            });
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV2ATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productV2ATC').addEventListener("click", addToCart);


    // changing from OTP to Subscription
    section.querySelectorAll(".productBuyingOption").forEach((el) => {
        el.addEventListener("click", function () {

            // if the buying option is already active, return
            if (this.classList.contains("active")) return;

            this.closest(".productV2Inner")
                ?.querySelectorAll(".productBuyingOption.active")
                ?.forEach((item) => {
                    // if the buying option doesn't match the data plan attribute, remove active class from each
                    if (item.dataset.plan !== el.dataset.plan) {
                        item.classList.remove("active");
                    }
                    // if the buying option matches the data plan attribute, add active class
                    section.querySelectorAll(".productBuyingOption")?.forEach((e) => {
                        if (e.dataset.plan === el.dataset.plan) {
                            e.classList.add("active");
                        }
                    });
                });

            // update prices to reflect new plan selection
            updateProduct().catch(err => console.error(err));
        });
    });

    /*********
     Sticky ATC
     **********/

    // if the sticky atc is on the page
    if (stickyATC) {
        // listener on scroll, show when past visual on tablet/mobile
        const trigger = document.querySelector('.productV2Visual');
        // watch the visual section, when off-screen allow the sticky to show
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // visual section, the top of page, is visible
                if (entry.isIntersecting) {
                    stickyATC.classList.remove('active');
                } else {
                    stickyATC.classList.add('active');
                }
            });
        });

        observer.observe(trigger);

        // sticky atc
        stickyATC.querySelector('.productV2StickyAtc').addEventListener("click", addToCart);
    }

    /***************
     Content Info
     ***************/

    // toggle accordion items, close others when a new one is opened
    section.querySelectorAll(".productV2ContentInfoItemTitle").forEach(function (element) {
        element.addEventListener("click", function () {
            if (this.classList.contains("active")) {
                this.classList.remove("active");
                return;
            }
            section.querySelectorAll(".productV2ContentInfoItemTitle.active").forEach(function (el) {
                el.classList.remove("active");
            });
            this.classList.add("active");
        });
    });

}());